// 
var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// 
document.addEventListener("DOMContentLoaded", function() {
// First Swiper Slider
var swiper1 = new Swiper(".first-slider", {
  loop: true,
  drag: 'free',
  slidesPerView: 1,
  pagination: {
    el: ".first-slider .swiper-pagination",
    clickable: true,
  },
});

// Second Swiper Slider
var swiper2 = new Swiper(".second-slider", {
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 15,
  drag: 'free',
  autoplay: {
    delay: 5000
 },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 1.2
    },
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    },
    1280: {
      slidesPerView: 4
    }
  }
  });

  // Third Swiper Slider
  var swiper3 = new Swiper(".third-slider", {
    loop: true,
    spaceBetween: 15,
    drag: 'free',
    autoplay: {
      delay: 7000,
      disableOnInteraction: false, 
      pauseOnMouseEnter: true, 
    },
    a11y: {
      enabled: true, 
    },
    breakpoints: {
      600: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 2
      },
      1280: {
        slidesPerView: 2
      },
      1536: {
        slidesPerView: 3
      }
    }
  });

  // Four Swiper Slider
  var swiper4 = new Swiper(".four-slider", {
    loop: true,
    spaceBetween: 15,
    drag: 'free',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false, 
      pauseOnMouseEnter: true, 
    },
    a11y: {
      enabled: true, 
    },
    breakpoints: {
      0: {
        slidesPerView: 2
      },
      600: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 6
      },
      1280: {
        slidesPerView: 7
      },
      1536: {
        slidesPerView: 8
      }
    }
  });
  
});

// highlight menu
// window.addEventListener("load", function () {
//   document.querySelectorAll(".h6").forEach(function (link) {
//     if (link.textContent.trim().toUpperCase() === "ATHLETES") {
//       link.style.color = "#f4ff71";
//     }
//   });
// });


  // Detect Safari (excluding Chrome and Android)
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    document.querySelectorAll('.media-document.video.mac').forEach(function(el) {
      el.classList.add('safari-fix');
    });
  }


